var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwipeLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2663 2.75012C21.2133 3.24321 20.2307 3.8691 19.3428 4.61186C19.2666 4.67557 19.2178 4.76092 19.1993 4.8524L19.1984 4.85722M21.2128 7.97838C20.433 7.11598 19.7694 6.15839 19.2385 5.12973C19.1937 5.04304 19.1813 4.9473 19.1984 4.85722M19.1984 4.85722L19.1667 4.8524M19.1984 4.85722C23.1182 5.45595 26.6636 7.19263 29.4869 9.71955M12.1836 27.0232L4.46626 20.0803C3.99858 19.6595 4.00121 18.9254 4.47192 18.5081C5.91947 17.2243 8.05491 17.0907 9.6513 18.1837L12.0065 19.7963L8.5556 6.91725C8.17442 5.49467 9.01864 4.03244 10.4412 3.65126C11.8638 3.27007 13.326 4.1143 13.7072 5.53688L15.7778 13.2643L22.2469 12.6371C26.9902 12.1774 28.5588 17.2671 28.1831 21.1305C27.5212 27.9351 17.1965 31.5331 12.1836 27.0232Z",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwipeLeft);
export default __webpack_public_path__ + "static/media/SwipeLeft.a0db4bfc0828edd4d68c3b1618797dfc.svg";
export { ForwardRef as ReactComponent };